import React, { Fragment } from 'react';
import { injectIntl } from 'react-intl';
import moment from 'moment';

const formattedDateTime = (date, t) => {
  const formatDate = moment(date);
  const today = moment();

  if (formatDate.isSame(today, 'day')) {
    return formatDate.format(t.today_time);
  }

  if (formatDate.isSame(today.subtract(1, 'days'), 'day')) {
    return formatDate.format(t.yesterday_time);
  }

  return formatDate.format(t.full_datetime);
};

const GroupsLabel = (props) => {
  const len = props.groups.length - 1;
  return props.groups.map((item, idx) => {
    let groupName = item;
    // map group name to tiers, we will update it in backend
    // and after it remove it from here
    if (item === 'G0') {
      groupName = 'TIER 1';
    }
    if (item === 'G1') {
      groupName = 'TIER 2';
    }
    if (item === 'G2') {
      groupName = 'TIER 3';
    }
    return len === idx ? (
      <strong key={idx}>{groupName}</strong>
    ) : (
      <strong key={idx}>{groupName} </strong>
    );
  });
};

const NotLaunched = ({ t }) => {
  return <>{t.offers_does_not_exists}</>;
};

const OfferedAsUpgrade = ({ driverName, journeyId, t }) => {
  return (
    <>
      <div>{t.offered_as_upgrade}</div>
      <div>
        <strong>{driverName}</strong> <span data-testid={'upgrade-journey-id'}>(J{journeyId})</span>
      </div>
    </>
  );
};
const LastOfferStats = ({ lastOfferStats, t }) => {
  if (!lastOfferStats) {
    return null;
  }
  return (
    <>
      <div>
        {t.viewed}: {lastOfferStats?.viewed_count ?? '-'}
      </div>
      <div>
        {t.accepted}: {lastOfferStats?.accepted_count ?? '-'}
      </div>
      <div>
        {t.rejected}: {lastOfferStats?.rejected_count ?? '-'}
      </div>
    </>
  );
};

const MinervaInfo = ({ minervaInfo, intl }) => {
  const t = intl.messages.modules.statusInfo.minervaInfo;
  if (!!minervaInfo?.error) {
    return <NotLaunched t={t} />;
  }

  const { data } = minervaInfo || {};
  const { expired_at, improvement } = data || {};

  if (expired_at) {
    return <NotLaunched t={t} />;
  }

  if (improvement) {
    return (
      <OfferedAsUpgrade
        driverName={improvement.driver_name}
        journeyId={improvement.journey_id}
        t={t}
      />
    );
  }

  if (!!minervaInfo?.data) {
    const now = new Date();
    const priorityGroups = minervaInfo.data.priority_groups;
    const launchedAt = minervaInfo.data.launched_at;
    const lastOfferStats = minervaInfo.data.last_offer_stats;

    const allGroups = priorityGroups.flatMap((x) => x.groups);
    const launchedGroups = priorityGroups
      .filter((x) => new Date(x.begins_at) <= now)
      .flatMap((x) => x.groups);

    if (allGroups.length === launchedGroups.length) {
      const priorityGroupEntry = priorityGroups[priorityGroups.length - 1] || {};
      const lastLaunchTime = priorityGroupEntry.begins_at;
      const isCustomGroup = priorityGroupEntry.groups?.indexOf('CUSTOM') >= 0;
      const groups = isCustomGroup ? ['CUSTOM POOL'] : ['ALL'];
      const dateFormats = intl.messages.date_formats;
      const dt = formattedDateTime(lastLaunchTime || launchedAt, dateFormats);
      return (
        <Fragment>
          {t.launched_to}
          <GroupsLabel groups={groups} />
          {' / '}
          {dt}
          <LastOfferStats lastOfferStats={lastOfferStats} t={t} />
        </Fragment>
      );
    }

    return (
      <Fragment>
        {t.launched_to_specific_groups} <GroupsLabel groups={launchedGroups} />
        <LastOfferStats lastOfferStats={lastOfferStats} t={t} />
      </Fragment>
    );
  }

  return <Fragment>{t.loading}</Fragment>;
};

MinervaInfo.propTypes = {};

export default injectIntl(MinervaInfo);
